module.exports = __webpack_public_path__ + "static/alpine-helicopter-logo-a71b4f2adb3b2e8fd0b8faf3a9efdb91.jpg";